"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const navigationHelpers_1 = require("evolution-common/lib/services/questionnaire/sections/navigationHelpers");
const widgetsNames_1 = require("./widgetsNames");
const helper_1 = require("../../common/helper");
const customHelpers_1 = require("../../common/customHelpers");
exports.currentSectionName = 'longDistance';
const previousSectionName = 'personsTrips';
const nextSectionName = 'end';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Fin',
        en: 'End'
    },
    navMenu: {
        type: 'inNav',
        menuName: {
            fr: 'Fin',
            en: 'End'
        }
    },
    widgets: widgetsNames_1.widgetsNames,
    // Allow to click on the section menu
    enableConditional: function (interview) {
        return (0, helper_1.allPersonsTripDiariesCompleted)(interview);
    },
    // Allow to click on the section menu, completed when the 'end' child section is completed
    completionConditional: function (interview) {
        return (0, navigationHelpers_1.isSectionCompleted)({ interview, sectionName: nextSectionName });
    },
    onSectionEntry: customHelpers_1.updateHouseholdSizeFromPersonCount
};
exports.default = exports.sectionConfig;
